{{set divide = {flag:true} }}
<div class="mfunsPlayer-player-set-mask">
  <div class="mfunsPlayer-player-set-headbar">
    <ul class="inner-wrap">
      <li class="mfunsPlayer-player-set headbar-item mirror">
        <div class="icon"></div>
        <div class="label">镜像翻转</div>
      </li>
      <li class="mfunsPlayer-player-set headbar-item filter">
        <div class="icon"></div>
        <div class="label">视频滤镜</div>
      </li>
      <li class="mfunsPlayer-player-set headbar-item color">
        <div class="icon"></div>
        <div class="label">色彩调节</div>
      </li>
      <li class="mfunsPlayer-player-set headbar-item timeClose">
        <div class="icon"></div>
        <div class="label">定时关闭</div>
        <div class="wait-tip"></div>
      </li>
      <li class="mfunsPlayer-player-set headbar-item feedback">
        <div class="icon"></div>
        <div class="label">播放反馈</div>
      </li>
    </ul>
  </div>
  <div class="mfunsPlayer-player-set-main">
    <div class="mfunsPlayer-player-set-row aspect-ratio">
      <div class="mfunsPlayer-player-set-title">画面比例</div>
      <ul class="mfunsPlayer-player-set-options-group">
        <li class="mfunsPlayer-player-set-option focus">自动</li>
        <li class="mfunsPlayer-player-set-option">16:9</li>
        <li class="mfunsPlayer-player-set-option">4:3</li>
        <li class="mfunsPlayer-player-set-option">拉伸</li>
        <li class="mfunsPlayer-player-set-option">填充</li>
      </ul>
    </div>

    <div class="mfunsPlayer-player-set-row play-mode">
      <div class="mfunsPlayer-player-set-title">播放方式</div>
      <ul class="mfunsPlayer-player-set-options-group">
        <li class="mfunsPlayer-player-set-option {{ if !autoSwitch&&!loop&&!listLoop }} focus {{ /if }}">播完暂停</li>
        <li class="mfunsPlayer-player-set-option {{ if !autoSwitch&&loop&&!listLoop }} focus {{ /if }}">洗脑循环</li>
        <li class="mfunsPlayer-player-set-option {{ if !loop&&listLoop }} focus {{ /if }}">列表循环</li>
        <li class="mfunsPlayer-player-set-option {{ if autoSwitch&&!loop }} focus {{ /if }}">自动切集</li>
      </ul>
    </div>
  </div>
</div>

<div class="mfunsPlayer-player-videoFilter-mask">
  <div class="mfunsPlayer-videoFilter-list">
    <div class="mfunsPlayer-videoFilter-item focus" data-value="">无滤镜</div>
    <div class="mfunsPlayer-videoFilter-item" data-value="grayscale(1)">黑白</div>
    <div class="mfunsPlayer-videoFilter-item" data-value="sepia(0.5)">护眼</div>
    <div class="mfunsPlayer-videoFilter-item" data-value="invert(1)">反色</div>
  </div>
</div>

<div class="mfunsPlayer-player-videoColor-mask mfunsPlayer-controller-panel">
  <div class="mfunsPlayer-set-item">
    <div class="mfunsPlayer-set-title">视频色彩设置</div>
    <div class="mfunsPlayer-panel-row">
      <div class="row-title">饱和度</div>
      <div class="mfunsPlayer-filter-saturate-slider mfunsPlayer-slider">
        {{ include '../slider.art' }}
      </div>
      <div class="mfunsPlayer-filter-saturate-value row-value">-</div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="row-title">对比度</div>
      <div class="mfunsPlayer-filter-contrast-slider mfunsPlayer-slider">
        {{ include '../slider.art' }}
      </div>
      <div class="mfunsPlayer-filter-contrast-value row-value">-</div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="row-title">亮度</div>
      <div class="mfunsPlayer-filter-brightness-slider mfunsPlayer-slider">
        {{ include '../slider.art' }}
      </div>
      <div class="mfunsPlayer-filter-brightness-value row-value">-</div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="row-title">色相旋转</div>
      <div class="mfunsPlayer-filter-hue-rotate-slider mfunsPlayer-slider">
        {{ include '../slider.art' divide}}
        <ul class="slider-tip">
          <li class="slider-tip-item">0</li>
          <li class="slider-tip-item">90</li>
          <li class="slider-tip-item">180</li>
          <li class="slider-tip-item">270</li>
          <li class="slider-tip-item">360</li>
        </ul>
      </div>
      <div class="mfunsPlayer-filter-hue-rotate-value row-value">-</div>
    </div>
    <div class="mfunsPlayer-video-color-reset-btn">重置</div>
  </div>

  <div class="mfunsPlayer-set-item">
    <div class="mfunsPlayer-set-title">参数解释</div>
    <div class="mfunsPlayer-panel-row">
      <h4>饱和度</h4>
      <div class="param-explain">饱和度越高，图像颜色越鲜艳，默认值为 100%，表示原始图像；0% 表示图像完全不饱和</div>
    </div>

    <div class="mfunsPlayer-panel-row">
      <h4>对比度</h4>
      <div class="param-explain">
        图像对比度指的是一幅图像中明暗区域最亮的白和最暗的黑之间不同亮度层级的测量，即指一幅图像灰度反差的大小，默认值为
        100％，代表原始图像；0％ 将使图像完全变黑；当值超过 100％ 时图像将获得更高的对比度
      </div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <h4>亮度</h4>
      <div class="param-explain">
        图像的亮度，默认值为 100％，代表原始图像；0％ 表示没有亮度，图像将完全变黑；当值超过 100％ 时图像将变得更亮
      </div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <h4>色相旋转</h4>
      <div class="param-explain">
        图像应用色相旋转，可使图像颜色产生偏移，该值用来定义色环的度数，默认值为 0deg，代表原始图像，最大值为 360deg
      </div>
    </div>
  </div>
</div>
<div class="mfunsPlayer-player-timeClose-mask">
  <div class="mfunsPlayer-timeClose-list">
    <div class="mfunsPlayer-timeClose-item focus" data-time="0">不开启</div>
    <div class="mfunsPlayer-timeClose-item" data-time="15">15分钟</div>
    <div class="mfunsPlayer-timeClose-item" data-time="30">30分钟</div>
    <div class="mfunsPlayer-timeClose-item" data-time="60">60分钟</div>
  </div>
</div>
<div class="mfunsPlayer-player-feedback-mask">
  <div class="inner-wrap">
    <p>如果播放中出现问题可以在此反馈哦~</p>
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">视频无法播放</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">视频播放卡顿</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">画面黑屏</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">无声音</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">弹幕无法显示</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">弹幕丢帧</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">手势控制失效</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">其他</div>
      </div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-feedback-detail"></div>
    </div>

    <div class="mfunsPlayer-feedback-submit">提交</div>
  </div>
</div>
<div class="mfunsPlayer-player-danmaku-report-mask">
  <div class="inner-wrap">
    <p class="danmaku-content">-</p>
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">违法违禁</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">人身攻击</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">色情低俗</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">政治敏感</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">恶意刷屏</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">引战</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">侵犯隐私</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">垃圾广告</div>
      </div>
      <div class="mfunsPlayer-switch">
        <div class="mfunsPlayer-switch-checkbox"></div>
        <div class="mfunsPlayer-switch-label">其他</div>
      </div>
    </div>
    <div class="mfunsPlayer-panel-row">
      <div class="mfunsPlayer-danmaku-report-detail"></div>
    </div>

    <div class="mfunsPlayer-danmaku-report-submit">提交</div>
  </div>
</div>